import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material';
import { VisitorProvider } from '../context/VisitorContext';
import { PageHeader } from '../components/VisitorList/PageHeader';
import { VisitorTable } from '../components/VisitorList/VisitorTable';
import { ErrorSnackbar } from '../components/VisitorList/ErrorSnackbar';
import type { Visitor } from '../../../shared/services/visitors/visitorService';
import { useVisitor } from '../context';
import { useNavigate } from 'react-router-dom';


function VisitorListContent() {
  const theme = useTheme();
  const navigate = useNavigate();
  
  const { 
    visitors, 
    isLoading, 
    error, 
    handleCreate, 
    handleCloseError,
  } = useVisitor();
  const handleView = (visitor: Visitor) => {
    navigate(`/visitors/${visitor.id}`);
  };

  return (
    <>
      <ErrorSnackbar error={error} onClose={handleCloseError} />
      <Box style={{ 
        background: theme.palette.background.paper, 
        borderRadius: 16, 
        padding: 32, 
        boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
        maxWidth: '100%', 
        margin: '0 auto' 
      }}>
        <PageHeader onCreate={handleCreate} isLoading={isLoading} />
        <VisitorTable
          visitors={visitors}
          isLoading={isLoading}
          onView={handleView}
        />
      </Box>

    </>
  );
}

export default function VisitorListPage() {
  return (
    <VisitorProvider>
      <VisitorListContent />
    </VisitorProvider>
  );
}